// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__N6FXN","icon":"SortAdornment_icon__Nujb6","up":"SortAdornment_up__33Ru2","down":"SortAdornment_down__1lBQk","active":"SortAdornment_active__2I_5x"};